import React from 'react';

import { Container, StyledButton, AddCardIcon } from './styles';

interface Props {
  label: string;
  onClick: () => void;
  icon?: string;
}

const SimpleButton = ({ label, onClick, icon }: Props) => (
  <Container>
    <StyledButton onClick={onClick}>
      <span>
        {icon ? <img src={icon} alt="" /> : <AddCardIcon />}
        {label}
      </span>
    </StyledButton>
  </Container>
);

export default SimpleButton;
